<template>
  <div class="introducer-report">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-date" /> Account Balance incorrect Report</span>
        <div style="float:right" />
      </div>

      <el-form :inline="true" size="medium">
        <!-- <el-form-item label="Search Date">
          <el-date-picker
            v-model="dateSearch"
            type="daterange"
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
            format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" :loading="loading" @click="getAccountList()">Query</el-button>
          <!-- <el-button icon="el-icon-download" type="success" @click="ExcelReport()">Excel</el-button> -->
          <!-- <el-button icon="el-icon-download" type="danger" @click="PDFReport()">PDF</el-button> -->
        </el-form-item>
      </el-form>

      <data-tables
        v-if="dataTable.length > 0"
        v-loading="loading"
        :data="dataTable"
        border
        :page-size="20"
        :pagination-props="{ background: true, pageSizes: [20, 50, 100, 200] }">
        <el-table-column prop="bankholderID" label="BankholderID" header-align="center" align="center" width="150"></el-table-column>
        <el-table-column prop="projectName" label="Project" header-align="center" align="center"></el-table-column>
        <el-table-column prop="ledgerID" label="ledgerID" header-align="center" align="center"></el-table-column>
        <el-table-column prop="checkDate" label="Check Date" header-align="center" align="center"></el-table-column>

        <el-table-column prop="bankholderID" label="Action" header-align="center" align="center">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-circle-check"
                @click="openNewTab(scope.row.bankholderID)"
                >View</el-button>
            </template>
        </el-table-column>
      </data-tables>
    </el-card>
  </div>
</template>

<script>
import { getMismatchAccountList } from '@/api/account-audit'

export default {
  props: {
    project: String
  },
  watch: {
      project(val, old) {
        this.project_uid = val;
        this.getAccountList()
      }
  },

  data() {
    return {
      loading: false,
      project_uid: '',
      dataTable: []
    }
  },
  methods: {
    getAccountList() {
      if (!this.project) {
          this.dataTable = []
          return
      }
      this.loading = true

      // this.SelectDate();
      getMismatchAccountList(this.project).then(({ result, data }) => {
        this.loading = false
        if (result) {
          this.dataTable = data
        }
      })
    },
    openNewTab(bankholderID) {
        window.open('/bank-account/view/customer/' + bankholderID, '_blank')
    }
  },
  created() {
    this.project_uid = this.project
    this.getAccountList()
  }
}
</script>
<style>
</style>
